<template>
    <thead class="bg-gray-50">
        <tr>
            <slot />
        </tr>
    </thead>
</template>
